export default __webpack_public_path__ + "static/media/icon-like.448371d6.svg";